import {i18n} from 'mc/lib';
import {ModalActions} from 'mc/lib/modal';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Obdobi from './Obdobi';
import ObdobiField from './ObdobiField';
import './ObdobiListField.scss';
import ObdobiListForm from './ObdobiListForm';
import {obdobiPropType} from './utils';

function normalizeItems(items) {
    return items.length ? items : [{}]; // Seznam období musí mít alespoň 1 prvek
}

/**
 * Pole pro zadání seznamu SH období.
 */
class ObdobiListField extends PureComponent {

    static propTypes = {
        value: PropTypes.arrayOf(obdobiPropType),
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        dispatch: PropTypes.func,
    };

    handleShowModal = () => {
        const formProps = {
            initialValues: {obdobiList: this.getItems()},
            onSubmit: this.handleMultipleItemsChange
        };
        this.props.dispatch(ModalActions.show(ObdobiListForm, formProps, i18n('obdobi'), {size: 'full'}));
    };

    handleSingleItemChange = obdobi => {
        this.handleChange([obdobi]);
    };

    handleMultipleItemsChange = ({obdobiList}) => {
        this.props.dispatch(ModalActions.hide());
        this.handleChange(normalizeItems(obdobiList));
    };

    handleChange(value) {
        const {onChange} = this.props;
        if (onChange) {
            onChange(value);
        }
    }

    getItems() {
        return normalizeItems(this.props.value);
    }

    renderSingleItem(item) {
        const {onFocus, onBlur} = this.props;
        return <ObdobiField value={item} onChange={this.handleSingleItemChange}
                            onFocus={onFocus} onBlur={onBlur}/>
    }
    renderMultipleItems(items) {
        return (
            <div className="obdobi-list-field">
                {items.map((item, index) => <Obdobi key={index} obdobi={item}/>)}
            </div>
        );
    }

    render() {
        const items = this.getItems();
        const hasMultipleItems = items.length > 1;

        return (
            <div>
                {hasMultipleItems
                    ? this.renderMultipleItems(items)
                    : this.renderSingleItem(items[0])
                }
                <a href="#" onClick={this.handleShowModal}>
                    {i18n(hasMultipleItems ? 'global.update' : 'obdobi.more')}
                </a>
            </div>
        );
    }

}

export default connect()(ObdobiListField);
